var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.side === "origin"
    ? _c(
        "span",
        {
          key: _vm.isSelected,
          staticClass: "entry-label",
          class: { selected: _vm.isSelected }
        },
        [
          _vm._v(
            "\n  " + _vm._s("(" + _vm.numberInCable + ") " + _vm.name) + "\n"
          )
        ]
      )
    : _c(
        "span",
        { staticClass: "entry-label", class: { selected: _vm.isSelected } },
        [
          _vm._v(
            "\n  " + _vm._s(_vm.name + " (" + _vm.numberInCable + ")") + "\n"
          )
        ]
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2affa04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2affa04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/ConnectionPointName.vue
// module id = null
// module chunks = 